module.exports = __webpack_public_path__ + "static/img/club-evnet-01.2e443ce.jpg";